// TODO - Possibly rename this to AllCaseRemarks or something similar.
import { BrainCircuit, ScanSearch, Microscope, TextIcon } from 'lucide-react';

export const DEFAULT_REMARKS_ICON = ScanSearch;

export enum AnalysisRemarkKeys {
    CaseOverview = 'analysis_remarks_case_overview',
    PortfolioAnalysis = 'analysis_remarks_portfolio_analysis',
    InterviewFindings = 'analysis_remarks_interview_findings',
    ProfileIdentity = 'analysis_remarks_identity_profile',
    CollateralValuation = 'analysis_remarks_collateral_and_valuation',
    ModusOperandi = 'obs_modus_operandi',
    Lapses = 'obs_lapses',
    AdditionalDetails = 'obs_additional_details',
    Recommendations = 'rec_main',
    AdditionalAnalysis = 'additional_analysis'
}


type RemarkDisplayConfig = {
    title: string;
    placeholder: string;
    icon: React.ComponentType<{ className?: string }>;
};
  
export const REMARK_DISPLAY_CONFIG: Record<AnalysisRemarkKeys, RemarkDisplayConfig> = {
  [AnalysisRemarkKeys.CaseOverview]: {
    title: "Remarks",
    placeholder: "Add overview comments after analyzing case fetch...",
    icon: DEFAULT_REMARKS_ICON,
  },
  [AnalysisRemarkKeys.ProfileIdentity]: {
    title: "Remarks",
    placeholder: "Add remarks after analyzing borrower profile...",
    icon: DEFAULT_REMARKS_ICON,
  },
  [AnalysisRemarkKeys.PortfolioAnalysis]: {
    title: "Remarks",
    placeholder: "Add remarks after portfolio analysis",
    icon: DEFAULT_REMARKS_ICON,
  },
  [AnalysisRemarkKeys.InterviewFindings]: {
    title: "Remarks",
    placeholder: "Add remarks after analyzing interviews",
    icon: DEFAULT_REMARKS_ICON,
  },
  [AnalysisRemarkKeys.CollateralValuation]: {
    title: "Remarks",
    placeholder:
      "Add remarks after analyzing collateral verification & valuation",
    icon: DEFAULT_REMARKS_ICON,
  },
  [AnalysisRemarkKeys.Recommendations]: {
    title: "Remarks",
    placeholder: "Add key recommendations for the case",
    icon: DEFAULT_REMARKS_ICON,
  },
  [AnalysisRemarkKeys.ModusOperandi]: {
    title: "Modus Operandi",
    placeholder: "Add remarks after analyzing how the fraud was perpetrated",
    icon: BrainCircuit,
  },
  [AnalysisRemarkKeys.Lapses]: {
    title: "Process & Policy Lapses",
    placeholder: "Add remarks regarding Lapses, if any",
    icon: Microscope,
  },
  [AnalysisRemarkKeys.AdditionalDetails]: {
    title: "Additional Observations",
    placeholder: "Additional notes",
    icon: TextIcon,
  },
  [AnalysisRemarkKeys.AdditionalAnalysis]: {
    title: "Remarks",
    placeholder: "Additional analysis",
    icon: TextIcon,
  },
};


export type RemarkKeyType = keyof typeof AnalysisRemarkKeys;